import React from "react";

import {
  OptionEnum,
  OptionModeEnum,
  OptionTypeEnum,
} from "@/components/Option";

import { Flexbox, Result, Text, WhiteBox } from "./styles";

export type ResultBarProps = {
  mode: OptionModeEnum;
  type: OptionTypeEnum;
  percent?: number;
  votes?: number;
  answer?: OptionEnum;
  isSecret?: boolean;
  isMultipleChoice?: boolean;
  isFinished?: boolean;
};

export const ResultBar: React.FC<ResultBarProps> = ({
  answer,
  percent,
  votes,
  mode,
  type,
  isSecret,
  isMultipleChoice,
  isFinished,
}: ResultBarProps): React.JSX.Element => (
  <WhiteBox>
    <Flexbox
      $type={type}
      $mode={mode}
      $answer={answer}
      $center={isSecret || isMultipleChoice}
    >
      <Result
        $answer={answer}
        $mode={mode}
        $percent={percent} // css transition
        $progressBar={!isSecret && !isMultipleChoice}
        $type={type}
      />
      {mode === OptionModeEnum.results && isFinished && !isSecret && (
        <Text
          $type={type}
          $answer={answer}
          $alignRight={!isMultipleChoice}
          $isMultipleChoice={isMultipleChoice}
        >
          {isMultipleChoice ? `${votes} Stimmen` : `${percent}%`}
        </Text>
      )}
    </Flexbox>
  </WhiteBox>
);
